import React, { useId } from 'react'
import PropTypes from 'prop-types'

const CautionTriangleIcon = React.forwardRef(function CautionTriangleIcon(
  props,
  ref
) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.029 3.16072C10.9828 3.25303 10.9337 3.35095 10.8804 3.45511C10.6398 3.92593 8.55413 8.03945 6.51704 12.0572C4.59396 15.8501 2.71416 19.5576 2.47068 20.0346C2.25018 20.4666 2.12293 20.8401 2.10102 21.1363C2.08205 21.3927 2.13974 21.5555 2.2871 21.7029C2.48717 21.903 2.7418 22 2.99 22H20.99C21.238 22 21.4955 21.9029 21.6978 21.708C21.8623 21.5413 21.9138 21.378 21.9005 21.1545C21.8843 20.8821 21.7651 20.5195 21.5198 20.0646L21.5143 20.0544L21.5143 20.0543C20.9698 19.0156 13.5539 4.35398 13.0975 3.45113C13.0498 3.35677 13.0054 3.26751 12.9633 3.1829C12.7722 2.79899 12.6289 2.51111 12.4452 2.27848C12.2618 2.04626 12.1389 2 11.99 2C11.8444 2 11.7213 2.04533 11.5358 2.28099C11.3547 2.51104 11.2145 2.79082 11.029 3.16072ZM9.9642 1.04401C10.3887 0.504669 11.0356 0 11.99 0C12.9411 0 13.5882 0.498739 14.0148 1.03902C14.341 1.45212 14.5958 1.96901 14.7852 2.35304C14.8198 2.42324 14.8522 2.48899 14.8825 2.54887C15.3454 3.46461 22.7275 18.0595 23.2831 19.1209C23.5866 19.6847 23.8558 20.3452 23.897 21.0355C23.941 21.7748 23.7187 22.5155 23.1071 23.1271L23.0979 23.1363L23.0979 23.1362C22.5208 23.6985 21.7603 24 20.99 24H2.99C2.21819 24 1.45282 23.697 0.872888 23.1171C0.240254 22.4845 0.0529374 21.7123 0.10647 20.9887C0.157062 20.3049 0.419811 19.6534 0.68931 19.1254C0.920919 18.6716 2.79207 14.9812 4.71291 11.1928C6.7613 7.15287 8.8662 3.00146 9.09956 2.54489C9.13134 2.4827 9.16567 2.4136 9.20254 2.33935C9.39006 1.96177 9.64352 1.45144 9.9642 1.04401Z"
        ></path>
        <path d="M12.5 17H11.5C11.2239 17 11 17.2239 11 17.5V18.5C11 18.7761 11.2239 19 11.5 19H12.5C12.7761 19 13 18.7761 13 18.5V17.5C13 17.2239 12.7761 17 12.5 17ZM12 7C11.45 7 11 7.45 11 8V14C11 14.55 11.45 15 12 15 12.55 15 13 14.55 13 14V8C13 7.45 12.55 7 12 7Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

CautionTriangleIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

CautionTriangleIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default CautionTriangleIcon
